import React from 'react';
import Axios from 'axios';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import {serverUrl} from './constants'

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import MySqlResponse from './MySqlResponse';
import MongoDbResponse from './MongoDbResponse';
import CsvResponse from './CsvResponse';

import ErrorRecap from './ErrorRecap';
import Form from './Form';


import logo from './res/logo_c4i.png';

import './App.css';

const MYSQL_VALUE = "MYSQL";
const MONGODB_VALUE = "MONGODB";
const CSV_VALUE = "CSV";
const DESTINATIONS = [{label: "MySQL", value: MYSQL_VALUE}, {label: "MongoDB", value: MONGODB_VALUE}, {label: "CSV", value: CSV_VALUE}];
const FORMID = "mainForm";

const theme = createMuiTheme({
	palette: {
		background: {
			default: '#e5e5e5'
		},
		primary: {
			main: '#1a1a1a',
			contrastText: '#00ffaa'
		},
		secondary: {
			main: '#1af69a',

		}
	},
	overrides: {
		MuiButton: {
			label: {
				textTransform: 'none'
			}
		}
	},
	props: {
		MuiButtonBase: {
			disableRipple: true // No more ripple on the whole application!
		}
	}
});

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			res: null,
			err: null,
			dest: null,
			processing: false
		};
		this.handleDest = this.handleDest.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleResponse = this.handleResponse.bind(this);
		this.handleError = this.handleError.bind(this);

		this.renderResponse = this.renderResponse.bind(this);
		this.renderError = this.renderError.bind(this);
	}
	handleDest(newValue) {
		this.setState({dest: newValue, err: null, res: null});
	}
	handleSubmit(formData) {
		this.setState({processing: true});
		Axios.post(serverUrl + '/validation', formData, {"Content-Type": "application/json"}).then(
			this.handleResponse
		).catch(
			this.handleError
		);
	}
	handleResponse(rawRes) {
		this.setState({err: null, res: rawRes, processing: false});
	}
	handleError(rawError) {
		// Response => Bad resquest. No response => Network error.
		const err = (rawError.response
			? {
				message: rawError.response.data.message,
				details: rawError.response.data.details,
				critical: rawError.response.data.critical
			}
			: {
				message: rawError.message
			}
		);
		this.setState({err: err, res: null, processing: false});
	}

	renderResponse() {
		const res = this.state.res;
		if(res) {
			switch(this.state.dest) {
				case MYSQL_VALUE:
					return Object.entries(res.data).map(([name, content], _) =>
						<MySqlResponse key={name} name={name} value={content}/>
					);
				case MONGODB_VALUE:
					return Object.entries(res.data).map(([name, content], _) =>
						<MongoDbResponse key={name} name={name} value={content}/>
					);
				case CSV_VALUE:
					return <CsvResponse/>;
				default:
					return (
						<ErrorRecap critical={true} message="Invalid destination" details={[]}/>
					);
			}
		}
	}
	renderError() {
		// Response => Bad resquest. No response => Network error.
		const err = this.state.err;
		return (err &&
			<ErrorRecap critical={err.critical} message={err.message} details={err.details}/>
		);
	}
	render() {
		return (
			<ThemeProvider theme={theme}>
					<img id="logo" className="centered" src={logo} alt="logo"></img>
					<Container>
						<Grid container direction="row-reverse" spacing={1}>
							<Grid item xs={12} md={2} lg={1}>
								<div id="stickyControls">
									<Button fullWidth variant="contained" color="primary" type="submit" form={FORMID}>{this.state.processing ? "Processing..." : "Process"}</Button>
								</div>
							</Grid>
							<Grid item xs={12} md={10} lg={11}>
								<Form formId={FORMID} url={serverUrl + '/validation'} dest={this.state.dest} destinations={DESTINATIONS} handleDest={this.handleDest} handleSubmit={this.handleSubmit}/>
								<hr/>
								{this.renderError()}
								{this.renderResponse()}
							</Grid>
						</Grid>
					</Container>
			</ThemeProvider>
		);
	}
}

export default App;